module.exports = __webpack_public_path__ + "static/media/garage-mid-grade.4151b539.jpg";